export const policies = {
  shippingPolicy: (
    <div className="space-y-6 text-black">
      <p className="text-black">
        At Harpalyk, we ensure your orders are securely packed and promptly shipped from our warehouse in Gurgaon, Haryana, India. Our goal is to deliver your product in perfect condition and on time.
      </p>

      <h3 className="text-2xl font-light text-gray-900 mt-8 mb-4">Estimated Delivery Timelines</h3>
      <p>
        <strong>Domestic (India-wide):</strong><br />
        3 to 7 business days from the date of order confirmation.<br />
        Delivery timelines may vary depending on location, courier service, and other logistical factors.
      </p>

      <h3 className="text-2xl font-light text-gray-900 mt-8 mb-4">Delivery Timings</h3>
      <ul className="list-disc pl-6 space-y-2">
        <li>Deliveries are made between 9:00 AM and 8:00 PM, Monday to Saturday.</li>
        <li>A signature is required upon delivery for verification.</li>
        <li>If you're unavailable at the time of delivery, please ensure an authorized person such as a family member, colleague, or neighbor is available to receive the parcel.</li>
      </ul>

      <h3 className="text-2xl font-light text-gray-900 mt-8 mb-4">Shipping Charges</h3>
      <p>Shipping and handling charges are calculated based on:</p>
      <ul className="list-disc pl-6 space-y-2">
        <li>Product category</li>
        <li>Packaging type</li>
        <li>Size and volume</li>
        <li>Destination location</li>
      </ul>
      <p className="mt-4">Exact shipping costs will be shown at checkout before you make your payment.</p>

      <h3 className="text-2xl font-light text-gray-900 mt-8 mb-4">Claims for Shortages or Damages</h3>
      <p>
        If you receive a shipment that is incomplete or damaged, please contact our customer support team on the same day of delivery. We'll ensure a prompt resolution to your issue.
      </p>

      <h3 className="text-2xl font-light text-gray-900 mt-8 mb-4">Important Notice on Delivery Delays</h3>
      <p>
        Due to factors beyond our control, delivery partners may occasionally face delays. While we aim for timely deliveries, we recommend placing your orders early if you have a deadline.
        Even if your shipment is delayed, we guarantee that it will reach you safely. We appreciate your understanding and patience.
      </p>

      <h3 className="text-2xl font-light text-gray-900 mt-8 mb-4">Need Help?</h3>
      <p>For questions or support, please contact our customer service team at:</p>
      <ul className="list-none space-y-2 mt-4">
        <li><strong>Email:</strong> support@harpalyk.com</li>
        <li><strong>Call Us:</strong> +91-7011370322</li>
        <li><strong>Working Hours:</strong> Monday to Friday, 9:30 AM – 5:00 PM</li>
      </ul>
    </div>
  ),

  warrantyPolicy: (
    <div className="space-y-6">
      <h2 className="text-3xl font-light text-gray-900 mb-4">WARRANTY SUPPORT POLICY</h2>
      <p>
        At Harpalyk Engineering Pvt. Ltd., every robot is backed by a 1 or 2-year warranty (depending on the robot model) along with pan-India service support, genuine spare parts and dedicated technicians.
      </p>

      <h3 className="text-2xl font-light text-gray-900 mt-8 mb-4">Warranty Policy</h3>
      <p>
        The entire Harpalyk team is grateful to have you as an esteemed customer. Your satisfaction is not just important to us—it's our highest priority. We are committed to delivering not only innovative technology but also exceptional service and support to ensure your experience exceeds expectations.
      </p>
      <p className="mt-4">
        If you have received a damaged or defective product or it is not as described, you can get a replacement at no extra cost if you report the case in writing to support@harpalyk.com within 2 days of delivery.
      </p>

      <h3 className="text-2xl font-light text-gray-900 mt-8 mb-4">Product Support & Training</h3>
      <p>
        After receiving your product, please contact our customer support team for assistance with setup and training. Our team will gladly guide you through every step. All support and training sessions are conducted online via video call for your convenience.
      </p>

      <h3 className="text-2xl font-light text-gray-900 mt-8 mb-4">Standard Warranty Coverage</h3>
      <p>Harpalyk robots are covered by a 1 or 2-year limited warranty (depending on the robot model — see your product page and invoice) against manufacturing defects in the following components:</p>
      <ul className="list-disc pl-6 space-y-2">
        <li>Electronic components</li>
        <li>Motors</li>
      </ul>
      <p className="mt-4">This warranty starts from the date of purchase and applies only to the original purchaser with valid proof of purchase (invoice or receipt).</p>

      <h4 className="text-xl font-light text-gray-900 mt-6 mb-3">Covered Under Warranty:</h4>
      <ul className="list-disc pl-6 space-y-2">
        <li>Faults arising due to manufacturing defects.</li>
        <li>Malfunctioning of electronic parts or motors under normal usage conditions.</li>
        <li>Remote diagnostics and assistance via phone or video call.</li>
      </ul>

      <h4 className="text-xl font-light text-gray-900 mt-6 mb-3">Not Covered Under Warranty:</h4>
      <ul className="list-disc pl-6 space-y-2">
        <li>Damage due to mishandling, accidents, water ingress, or unauthorized modifications</li>
        <li>Wear and tear parts such as: Cable, Floating Cable, Belts, Dust Bag, Brushes, Plastic & Aesthetic parts.</li>
        <li>Electrical damage caused by power surges, voltage fluctuations, or improper electrical connections</li>
        <li>Damage caused by external elements (e.g., dust, humidity, extreme temperatures), improper installation or incorrect setup</li>
      </ul>

      <h4 className="text-xl font-light text-gray-900 mt-6 mb-3">Important Notes:</h4>
      <ul className="list-disc pl-6 space-y-2">
        <li>Warranty is valid only with a proper purchase invoice.</li>
        <li>Repair or replacement under warranty will be at the sole discretion of the company.</li>
        <li>Any shipping or transportation charges related to servicing will be borne by the customer, unless stated otherwise.</li>
        <li>Never lift the pool robot by pulling its floating cable, as this may cause internal cable damage. Always use the designated handle to lift or move the robot.</li>
        <li>Any dispute arising out of or in connection with this warranty shall be subject to the exclusive jurisdiction of the courts in Gurgaon, Haryana only.</li>
      </ul>

      <h3 className="text-2xl font-light text-gray-900 mt-8 mb-4">Battery Warranty Policy</h3>
      <p>We stand behind the quality and performance of our products, including the battery systems.</p>
      <h4 className="text-xl font-light text-gray-900 mt-6 mb-3">Warranty Coverage</h4>
      <ul className="list-disc pl-6 space-y-2">
        <li>The battery is covered under warranty for a period of 6 months from the date of purchase.</li>
        <li>This warranty covers manufacturing defects in material and workmanship under normal residential use.</li>
        <li>If a defect arises during the warranty period, Harpalyk will, at its discretion, repair or replace the defective battery free of charge.</li>
      </ul>

      <h3 className="text-2xl font-light text-gray-900 mt-8 mb-4">Customer Support & Warranty Desk</h3>
      <p>We're here to help — because your satisfaction is our commitment.</p>
      <ul className="list-none space-y-2 mt-4">
        <li><strong>Email:</strong> support@harpalyk.com</li>
        <li><strong>Available:</strong> Monday–Saturday, 10:00 AM – 6:00 PM</li>
        <li><strong>Phone:</strong> +91-7011370322</li>
        <li><strong>Website:</strong> www.harpalyk.com</li>
      </ul>
    </div>
  ),

  returnPolicy: (
    <div className="space-y-6">
      <h2 className="text-3xl font-light text-gray-900 mb-4">Return & Refund Policy</h2>
      <p>
        At Harpalyk, we take utmost care to deliver premium hygiene-focused cleaning solutions that meet your expectations. We prioritize transparency and quality assurance at every step of the customer journey.
      </p>

      <h3 className="text-2xl font-light text-gray-900 mt-8 mb-4">Product Demonstration & Pre-Purchase Support</h3>
      <p>To ensure informed purchases, we offer:</p>
      <ul className="list-disc pl-6 space-y-2">
        <li>Detailed product information on all listings</li>
        <li>Virtual or onsite demonstrations, wherever feasible, based on customer requirements and location</li>
      </ul>
      <p className="mt-4">This helps customers understand the usage, application, and limitations of our products prior to purchase.</p>

      <h3 className="text-2xl font-light text-gray-900 mt-8 mb-4">No Refund or Replacement Policy</h3>
      <p>Due to the hygienic nature of our products and for the safety of all our customers, we maintain a strict No Refund and No Replacement Policy:</p>
      <ul className="list-disc pl-6 space-y-2">
        <li>Once a product is sold, it cannot be returned, exchanged, or refunded under any circumstances.</li>
        <li>This policy applies universally—whether the product is used or unused.</li>
      </ul>
      <p className="mt-4">We request customers to carefully evaluate the product and resolve any queries before purchase. Our support team is always available to assist in making the right decision.</p>

      <h3 className="text-2xl font-light text-gray-900 mt-8 mb-4">Exceptions – Dead on Arrival (DOA)</h3>
      <p>We only allow replacement in the rare event of a Dead on Arrival (DOA) product. Conditions for eligibility:</p>
      <ol className="list-decimal pl-6 space-y-2">
        <li>Issue must be reported within 2 days of receiving the product</li>
        <li>The defect must be verified and approved by our authorized service center</li>
        <li>Customer must email us at support@harpalyk.com (mention order ID, contact number, and include photos/videos of the issue)</li>
      </ol>
      <p className="mt-4">After validation, a replacement unit will be arranged at the earliest.</p>
      <p>Any physical damage, water damage, or signs of misuse will void this exception.</p>

      <h3 className="text-2xl font-light text-gray-900 mt-8 mb-4">Important Notes</h3>
      <ul className="list-disc pl-6 space-y-2">
        <li>Unauthorized returns or self-shipped products without prior approval will not be entertained or refunded.</li>
        <li>For any clarification, we recommend contacting our customer support before initiating any complaint or return.</li>
      </ul>

      <h3 className="text-2xl font-light text-gray-900 mt-8 mb-4">Our Commitment</h3>
      <p>
        We are committed to delivering products that are safe, effective, and reliable. While we do not offer refunds, we assure you of full support and service to resolve any legitimate concerns you may face.
      </p>
    </div>
  ),

  customerPolicy: (
    <div className="space-y-6">
      <h2 className="text-3xl font-light text-gray-900 mb-4">Customer Policy</h2>
      <p>
        At Harpalyk, we are committed to delivering not just exceptional products, but a seamless, secure, and satisfying customer experience—every step of the way.
      </p>

      <h3 className="text-2xl font-light text-gray-900 mt-8 mb-4">Secure Payment Experience</h3>
      <p>
        We've partnered with Instamojo, one of India's most reliable payment gateways, to ensure your transactions are fast, safe, and encrypted.
      </p>
      <h4 className="text-xl font-light text-gray-900 mt-6 mb-3">Supported Payment Options:</h4>
      <ul className="list-disc pl-6 space-y-2">
        <li>Credit & Debit Cards (Visa, MasterCard)</li>
        <li>UPI & Net Banking (if configured via Instamojo)</li>
        <li>Instant checkout on our official website</li>
      </ul>
      <p className="mt-4">All transactions are SSL-encrypted and compliant with the latest PCI-DSS standards, so you can shop with total confidence.</p>

      <h3 className="text-2xl font-light text-gray-900 mt-8 mb-4">Shipping Policy</h3>
      <p>
        We work with India's most trusted logistics partners—Bluedart, Delhivery, and Trackon—to ensure fast, secure, and reliable deliveries across the country.
      </p>
      <h4 className="text-xl font-light text-gray-900 mt-6 mb-3">What You Can Expect:</h4>
      <ul className="list-disc pl-6 space-y-2">
        <li>Free Shipping on all orders within India</li>
        <li>Fast Dispatch: Orders processed within 24 hours (business days)</li>
        <li>Estimated Delivery: Within 2 to 5 business days of dispatch</li>
        <li>Real-Time Tracking: You'll receive tracking details via email/SMS upon dispatch</li>
      </ul>

      <h3 className="text-2xl font-light text-gray-900 mt-8 mb-4">Order Changes & Special Requests</h3>
      <p>We understand plans change. For any order modifications or special delivery instructions:</p>
      <ul className="list-disc pl-6 space-y-2">
        <li>Contact us immediately after placing your order.</li>
        <li>Email: support@harpalyk.com</li>
        <li>Phone/WhatsApp: +91-7011370322</li>
      </ul>
      <p className="mt-4">We'll do our best to accommodate your request if your order hasn't already been dispatched.</p>

      <h3 className="text-2xl font-light text-gray-900 mt-8 mb-4">Delivery Confirmation & Handover</h3>
      <ul className="list-disc pl-6 space-y-2">
        <li>A signature or digital OTP confirmation may be required upon delivery to ensure secure receipt</li>
        <li>If unavailable, please authorize a family member, friend, or colleague to accept on your behalf</li>
      </ul>

      <h3 className="text-2xl font-light text-gray-900 mt-8 mb-4">In Case of Damaged or Missing Items</h3>
      <p>We take great care in packaging, but transit issues may rarely occur. If your product arrives damaged, tampered, or incomplete:</p>
      <ul className="list-disc pl-6 space-y-2">
        <li>Notify our support team within 24 hours of delivery</li>
        <li>Share photos or videos of the issue for faster resolution</li>
        <li>We'll arrange for a free replacement or refund, as per our return policy</li>
      </ul>

      <h3 className="text-2xl font-light text-gray-900 mt-8 mb-4">We're Always Here to Help</h3>
      <p>Need help tracking your order, making a payment, or handling an issue? Reach out to our dedicated customer care team:</p>
      <ul className="list-none space-y-2 mt-4">
        <li><strong>Email:</strong> support@harpalyk.com</li>
        <li><strong>Call or WhatsApp:</strong> +91-7011370322</li>
        <li><strong>Timings:</strong> Monday to Saturday | 10:00 AM – 6:00 PM</li>
      </ul>
      <p className="mt-6 text-center text-lg font-light">
        Harpalyk – Empowering smarter living through intelligent automation.<br />
        Because your time is valuable—and your experience matters.
      </p>
    </div>
  ),

  termsOfService: (
    <div className="space-y-6">
      <h2 className="text-3xl font-light text-gray-900 mb-4">Terms of Service</h2>
      
      <p>
        By accessing or using the Harpalyk website, products, or services, you agree to be bound by these Terms of Service, governed by the laws of India, including the Information Technology Act, 2000 and the Consumer Protection Act, 2019. Harpalyk Engineering Private Limited reserves the right to modify, update, or withdraw any part of its website, products, or services at its discretion.
      </p>

      <p>
        All content, trademarks, software, designs, and intellectual property on this website are the exclusive property of Harpalyk and are protected under applicable Indian laws. Unauthorized copying, distribution, reverse engineering, or commercial use is strictly prohibited.
      </p>

      <p>
        Harpalyk products are intended for domestic use only and must be operated in accordance with the instructions and safety guidelines provided. Any misuse, unauthorized modification, or use inconsistent with the user manual may void warranty and limit liability.
      </p>

      <p>
        To the maximum extent permitted by law, Harpalyk shall not be liable for indirect, incidental, or consequential damages. Warranty obligations and consumer rights shall be governed strictly as per applicable Indian consumer protection laws.
      </p>

      <p>
        Any dispute arising out of or relating to these Terms shall be subject to the exclusive jurisdiction of competent courts in India.
      </p>

      <h3 className="text-2xl font-light text-gray-900 mt-8 mb-4">Contact Us</h3>
      <p>For questions about these Terms of Service, please contact:</p>
      <ul className="list-none space-y-2 mt-4">
        <li><strong>Email:</strong> support@harpalyk.com</li>
        <li><strong>Phone:</strong> +91-7011370322</li>
        <li><strong>Address:</strong> Gurugram, Haryana, India</li>
      </ul>
    </div>
  ),

  cookiePolicy: (
    <div className="space-y-6">
      <h2 className="text-3xl font-light text-gray-900 mb-4">Cookie Policy</h2>
      <p>
        This Cookie Policy explains how Harpalyk Engineering Private Limited uses cookies and similar technologies when you visit our website.
      </p>

      <h3 className="text-2xl font-light text-gray-900 mt-8 mb-4">What Are Cookies?</h3>
      <p>
        Cookies are small text files that are placed on your device when you visit a website. They help the website remember your preferences and improve your browsing experience.
      </p>

      <h3 className="text-2xl font-light text-gray-900 mt-8 mb-4">Types of Cookies We Use</h3>
      
      <h4 className="text-xl font-light text-gray-900 mt-6 mb-3">1. Essential Cookies</h4>
      <p>These cookies are necessary for the website to function properly. They enable basic features like page navigation and access to secure areas.</p>

      <h4 className="text-xl font-light text-gray-900 mt-6 mb-3">2. Performance Cookies</h4>
      <p>These cookies collect information about how visitors use our website, such as which pages are visited most often. This helps us improve our website's performance.</p>

      <h4 className="text-xl font-light text-gray-900 mt-6 mb-3">3. Functionality Cookies</h4>
      <p>These cookies allow the website to remember choices you make and provide enhanced, personalized features.</p>

      <h4 className="text-xl font-light text-gray-900 mt-6 mb-3">4. Analytics Cookies</h4>
      <p>We use analytics cookies to understand how visitors interact with our website, helping us improve user experience.</p>

      <h3 className="text-2xl font-light text-gray-900 mt-8 mb-4">Managing Cookies</h3>
      <p>Most web browsers allow you to control cookies through their settings. You can:</p>
      <ul className="list-disc pl-6 space-y-2">
        <li>Delete existing cookies</li>
        <li>Block cookies from being set</li>
        <li>Accept or decline cookies on a case-by-case basis</li>
      </ul>
      <p className="mt-4">
        Please note that blocking or deleting cookies may impact your experience on our website and limit certain functionality.
      </p>

      <h3 className="text-2xl font-light text-gray-900 mt-8 mb-4">Third-Party Cookies</h3>
      <p>
        We may use third-party service providers who also set cookies on our website. These include payment processors and analytics providers. We do not control these third-party cookies.
      </p>

      <h3 className="text-2xl font-light text-gray-900 mt-8 mb-4">Updates to This Policy</h3>
      <p>
        We may update this Cookie Policy from time to time. Any changes will be posted on this page with an updated revision date.
      </p>

      <h3 className="text-2xl font-light text-gray-900 mt-8 mb-4">Contact Us</h3>
      <p>If you have questions about our use of cookies, please contact:</p>
      <ul className="list-none space-y-2 mt-4">
        <li><strong>Email:</strong> support@harpalyk.com</li>
        <li><strong>Phone:</strong> +91-7011370322</li>
        <li><strong>Website:</strong> www.harpalyk.com</li>
      </ul>

      <p className="mt-6 text-sm text-gray-500">Last updated: January 2026</p>
    </div>
  ),
};
